<div class="card table-page-card">
	@if (showSearch() || showFullscreen() || showColumnFilter()) {
		<div *transloco="let t" class="bg-app-bar px-6 h-16 border-b sticky left-0 flex flex-row justify-start items-center">
			@if (showSearch()) {
				<div class="bg-card rounded-full border px-4 bg-surface flex flex-row justify-start items-center w-full md:w-auto md:min-w-[360px]">
					<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
					<input
						#input
						[value]="searchValue() ?? ''"
						[delayedSearch]="searchSubject()"
						[size]="t(searchPlaceholder()).length + 2"
						class="px-4 py-3 border-0 outline-none w-full md:w-auto bg-transparent"
						matInput
						name="searchField"
						placeholder="{{ t(searchPlaceholder()) }}"
						[attr.aria-label]="t(searchPlaceholder())"
						type="search" />
				</div>
			}
			<!-- Caller-provided action buttons next to the search field (left) -->
			@if (searchActionsTemplate()) {
				<div class="flex flex-row items-center gap-1 ml-1">
					<ng-container *ngTemplateOutlet="searchActionsTemplate() ?? null"></ng-container>
				</div>
			}
			<span class="flex-1"></span>

			<!-- Caller-provided action buttons in the header (right-aligned) -->
			@if (headerActionsTemplate() && !isReadMode()) {
				<div class="flex flex-row items-center gap-1">
					<ng-container *ngTemplateOutlet="headerActionsTemplate() ?? null"></ng-container>
				</div>
			}

			@if (beta()) {
				<ara-info-badge class="ml-2 h-3.5" [trailingIcon]="trailingIconsService.BETA"></ara-info-badge>
			}
			@if (showFullscreen() && !isInDialog() && fullscreenHostTemplate()) {
				<ara-popover [content]="t('commonActions.fullscreen')">
					<button (click)="openFullscreen()" class="ml-4" araButton="icon" type="button">
						<mat-icon>open_in_full</mat-icon>
					</button>
				</ara-popover>
			}
			@if (showColumnFilter()) {
				<ara-popover [content]="t('commonActions.filterColumns')">
					<button [matMenuTriggerFor]="columnFilterMenu" class="ml-4" araButton="icon" type="button">
						<mat-icon [svgIcon]="icons.get('filterList')"></mat-icon>
					</button>
				</ara-popover>
			}
		</div>
	}

	@if (loading()) {
		<div class="spinner-style">
			<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
		</div>
	} @else {
		<!-- The caller's table or mobile view (via ngTemplateOutlet — works inside dialogs).
			 Hidden while loading so empty column headers / "no data" don't show behind the spinner. -->
		<ng-container *ngTemplateOutlet="tableTemplate() ?? null"></ng-container>
	}

	@if (showPaginator()) {
		<ara-paginator
			(page)="onPage($event)"
			[length]="length()"
			[pageIndex]="pageIndex()"
			[pageSizeOptions]="pageSizeOptions()"
			[pageSize]="pageSize()"
			[showFirstLastButtons]="true"
			class="sticky left-0"></ara-paginator>
	}

	<!-- Reserved action-button area (gray bar) — sits below the paginator -->
	@if (effShowActionBar() && actionBarTemplate()) {
		<div
			class="bg-app-bar flex flex-row flex-wrap justify-start items-center gap-2 px-4 py-2 border-t border-[color:var(--foreground-divider)] sticky left-0">
			<ng-container *ngTemplateOutlet="actionBarTemplate() ?? null"></ng-container>
		</div>
	}

	@if (footerTemplate()) {
		<ng-container *ngTemplateOutlet="footerTemplate() ?? null"></ng-container>
	}
</div>

<mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
	<div *transloco="let t">
		<div class="grid grid-rows grid-cols-1">
			@for (column of columns(); track column.property) {
				<button (click)="toggleColumnVisibility(column, $event)" class="checkbox-item mat-menu-item text-left">
					<ara-checkbox
						(click)="$event.stopPropagation()"
						(keydown)="$event.stopPropagation()"
						(keyup)="$event.stopPropagation()"
						[(ngModel)]="column.visible"
						color="primary">
						{{ t(column.label) }}
					</ara-checkbox>
				</button>
			}
		</div>
	</div>
</mat-menu>
